import { IonButton, IonContent, IonImg } from "@ionic/react";
import tableIcon from '../../assets/images/table.png';
interface Props {
  setShowModal2: Function;
}
const FloorTape: React.FC<Props> = ({ setShowModal2 }) => {
  return (
    <IonContent placeholder={undefined}>
      <div className="assessment-tape-wrap">
      <div className="text-center">
        <IonImg src={tableIcon} alt="tableIcon" placeholder={undefined}/>
        </div>
        <h1>DESK / TABLE</h1>
        <p>
        RED floor tape must be used to mark where the patient will begin and where they will end.
        </p>
        <IonButton
          className="generic-btn"
          onClick={() => setShowModal2(false)} placeholder={undefined}        >
          Close
        </IonButton>
      </div>
    </IonContent>
  );
};
export default FloorTape;
